import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import HeaderBottom from "../components/Admin/Settings/HeaderBottom";

const ErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>Oops! Something Went Wrong</title>
        <meta
          name="description"
          content="An error occurred while processing your request. Please try again later or contact support if the issue persists."
        />
      </Helmet>

      <HeaderBottom></HeaderBottom>

    <section className="error-area pt-140 pb-140">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-xl-6">
        <div className="error-wrap text-center">
          <div className="error-img mb-60 tp_fade_bottom">
            <img src="assets/images/bg/404.png" alt />
          </div>
          <div className="error-content">
            <h2 className="error-content-title tp_has_text_reveal_anim">Opos! Nothing Was Found</h2>
            <p className="tp_desc_anim">Something went wrong, Looks like this page doesn't <br />
              exist anymore.</p>
            <a href="/" className="theme-btn-2 tp_fade_bottom">Go Back Home</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  );
};

export default ErrorPage;
